<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <div>
    <tsl-card :cardList="cardList">
      <template v-slot:cost>
        <!-- class="middle" style="display: flex; justify-content: space-between" -->
        <div>
          <!-- <div class="left">
            <div class="con">
              <span class="total-title">总消费金额</span>
              <span class="detail">查看明细</span>
            </div>
            <div class="total-money">56,234.00</div>
          </div> -->
          <div class="rig">
            <a-select
              style="width: 120px"
              dropdownClassName="search-select-dropdown"
              placeholder="2022年"
              v-model:value="searchValue"
            >
              <a-select-option value="2021年">2021年</a-select-option>
              <a-select-option value="2021年">2022年</a-select-option>
            </a-select>
          </div>
        </div>
        <cost-chart></cost-chart>
      </template>
      <template v-slot:topRight>
        <div class="card-top-more">查看明细</div>
      </template>
    </tsl-card>
  </div>
</template>
<script>
import Card from "@/components/tsl-card/index.vue";
import Dcard from "@/components/dashboard/devops/devops-card.vue";
import Chart from "@/components/dashboard/devops/cost-chart.vue";
import { reactive, ref } from "vue";
import { Select } from "ant-design-vue";
export default {
  name: "devops-cost",
  components: {
    [Card.name]: Card,
    [Dcard.name]: Dcard,
    [Select.name]: Select,
    [Chart.name]: Chart,
    ASelectOption: Select.Option
  },
  props: {
    data: Object
  },
  setup() {
    const overviewList = ref([
      {
        name: "待办工单",
        value: 0
      },
      {
        name: "待支付订单",
        value: 0
      },
      {
        name: "待续费项",
        value: 0
      }
    ]);
    const cardList = reactive([
      {
        name: "cost",
        title: "费用",
        topRight: "topRight"
      }
    ]);
    const searchValue = ref(undefined);
    return {
      cardList,
      overviewList,
      searchValue
    };
  }
};
</script>
<style scoped lang="less">
.need-to {
  display: flex;
  .item {
    width: 30.4%;
    margin-right: 4.4%;
  }
  .item:nth-child(3n) {
    margin-right: 0;
  }
}
.total-title {
  margin-right: 13px;
  color: #4e5969;
  font-size: 14px;
}
.con {
  line-height: 22px;
}
.detail {
  color: #5d65fb;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
}
.total-money {
  height: 24px;
  margin-top: 4px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
}
:deep(.ant-select-selection-placeholder) {
  color: #1d2129;
}
</style>
